module.exports = __webpack_public_path__ + "static/media/sally_fail.e60169a2.png";